<template>
    <div class="trip-flight-selected" v-if="selectedFlight">
        <div class="trip-flight-selected-header">Flight Tickets</div>
        <div class="trip-flight-selected-body">
            <div class="trip-flight-selected-body-item" v-if="selectedFlight.adt">
                <span class="trip-flight-selected-body-item-label">Adult(s):</span>
                <span class="trip-flight-selected-body-item-text">{{ selectedFlight.adt.count }} x {{ selectedFlight.adt.totalPriceAmount | price }} = {{ selectedFlight.adt.totalPrice | price }}</span>
            </div>
            <div class="trip-flight-selected-body-item" v-if="selectedFlight.cnn">
                <span class="trip-flight-selected-body-item-label">Children:</span>
                <span class="trip-flight-selected-body-item-text">{{ selectedFlight.cnn.count }} x {{ selectedFlight.cnn.totalPriceAmount | price }} = {{ selectedFlight.cnn.totalPrice | price }}</span>
            </div>
            <div class="trip-flight-selected-body-item" v-if="selectedFlight.inf">
                <span class="trip-flight-selected-body-item-label">Infant(s):</span>
                <span class="trip-flight-selected-body-item-text">{{ selectedFlight.inf.count }} x {{ selectedFlight.inf.totalPriceAmount | price }} = {{ selectedFlight.inf.totalPrice | price }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {FLIGHTS_NAMESPACE, SELECTED_FLIGHT_GETTER} from '../store/modules/flights';
    import priceMixin from '../mixins/price';

    export default {
        name: 'trip-checkout-flight',
        mixins: [
            priceMixin
        ],
        /**
         * Getters from vuex storage
         */
        computed: mapGetters(FLIGHTS_NAMESPACE, [
            SELECTED_FLIGHT_GETTER
        ])
    };
</script>

<style lang="scss">
    .trip-flight-selected {

        &-header {
            color: $color-gray-dim;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 15px;
        }

        &-body {
            @import '../../../../scss/frontend/components/flight-details/price';
        }
    }
</style>